import React, { useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Icon } from '@iconify/react'
import styles from '../form.module.css'
import stylesPassword from './password.module.css'

// Assets
import iconoCandado from '../../../assets/icono-candado.png'

export const Password = ({ name = '', label = '', helpText = '', required = false, placeholder = '' }) => {
  const { control } = useFormContext()
  const [obscured, setObscured] = useState(true)

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => (
        <div className={styles.field}>
          <label className={styles.label} htmlFor={name}>{label} {required && <span className={styles.required}>*</span>}</label>

          <div className={styles.shell}>
            <span className={styles.prefix}><img src={iconoCandado} alt="Usuario" height={17} /></span>
            <input
              id={name}
              className={styles.input}
              type={obscured ? 'password' : 'text'}
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder={placeholder}
                autoComplete="new-password"
              // autoComplete="off"
              // autoComplete="current-password"
            />
            <button
              type="button"
              className={stylesPassword.toggleVisibility}
              onClick={() => setObscured((v) => !v)}
              aria-label={obscured ? 'Mostrar contraseña' : 'Ocultar contraseña'}
            >
              <Icon icon={obscured ? 'icomoon-free:eye' : 'icomoon-free:eye-blocked'} width={22} height={22} />
            </button>
          </div>

          {fieldState.error && <p className={styles.error}>{fieldState.error.message}</p>}

          {helpText && <p className={styles.helpText}>{helpText}</p>}
        </div>
      )}
    />
  )
}